import React from 'react';
import LandingAccordion from './LandingAccordion';
import laptopIllustration from '../../assets/images/landing/on-the-laptop.svg';
import { getContactEmail } from '../../utils/contact';
import { FAQS } from './landingContent';

const LandingFaq = () => {
 const email = getContactEmail();

 return (
 <section className="lp-section lp-section-paper" id="faq" aria-labelledby="faq-title">
 <div className="lp-wrap lp-faq">
 <div className="lp-faq-side lp-reveal">
 <p className="lp-eyebrow">07 - FAQ</p>
 <h2 id="faq-title">
 Straight
 <br />
 <span className="lp-accent-sans">answers.</span>
 </h2>
 <p className="lp-faq-note">
 Still have a question? Email us and a real advisor will reply - usually same business day.
 </p>
 <a className="lp-mail" href={`mailto:${email}`}>
 {email}
 </a>
 <img
 className="lp-art lp-art-laptop"
 src={laptopIllustration}
 alt=""
 width="320"
 height="304"
 loading="lazy"
 />
 </div>
 <LandingAccordion
 items={FAQS.map((item) => ({ question: item.q, answer: item.a }))}
 idPrefix="faq"
 itemClassName="lp-reveal"
 />
 </div>
 </section>
 );
};

export default LandingFaq;
